import config from '@/config';
import router from '@/router';

/**
 * Get full image path for device
 *
 * @param deviceType
 * @param relativePath
 * @return {string}
 */
const getFullImageUrl = (deviceType, relativePath) => {
  const baseUrl = config.imagesBucket[deviceType];

  return `${baseUrl}${relativePath}`;
};


/**
 * Get full Image url for desktop
 *
 * @param relativePath {String} - relative path to image, like 'ProductImages/1.jpg'
 * @return {string}
 */
export const desktopImageUrl = relativePath => getFullImageUrl('web', relativePath);


/**
 * Get full Image url for kiosk
 *
 * @param relativePath {String} - relative path to image, like 'ProductImages/1.jpg'
 * @return {string}
 */
export const kioskImageUrl = relativePath => getFullImageUrl('kiosk', relativePath);


/**
 * Get full Image url for mobile
 *
 * @param relativePath {String} - relative path to image, like 'ProductImages/1.jpg'
 * @return {string}
 */
export const mobileImageUrl = relativePath => getFullImageUrl('mobile', relativePath);

/**
 * Get full name.
 * @param userData
 * @returns {string}
 */
export const getFullName = userData => `${userData.firstName} ${userData.lastName}`;

/**
 * Capitalize first letter,
 * @param s
 * @return {string}
 */
export const capitalizeFirstLetter = (s) => {
  if (typeof s !== 'string') return '';

  return s.charAt(0).toUpperCase() + s.slice(1);
};

/**
 * Get platform type.
 * @return {string|undefined}
 */
export const getPlatformType = () => {
  const envPlatform = process.env.PLATFORM;

  if (envPlatform === 'mobile') {
    return 'device' in window ? device.platform : capitalizeFirstLetter(envPlatform);
  }

  return capitalizeFirstLetter(envPlatform);
};

/**
 * Get current app router.
 * @return { object }
 */
export function getAppRouter() {
  const platform = process.env.PLATFORM;

  if (platform === 'web') {
    return router.webRouter;
  } else if (platform === 'mobile') {
    return router.mobileRouter;
  } else if (platform === 'kiosk') {
    return router.kioskRouter;
  }

  throw new Error(`Wrong platform type: ${platform}`);
}

/**
 * Set query params without rout reloading and dom update.
 * @param {object} newQuery
 */
export function setQuerySilent(newQuery) {
  const { $route, $router } = getAppRouter().app;
  const isHashMode = $router.mode === 'hash';
  const searchString = isHashMode ? window.location.href.split('?')[1] : window.location.search;
  const searchParams = new URLSearchParams(searchString);
  const hash = isHashMode ? '#' : '';

  const params = {
    ...Object.fromEntries(searchParams), ...newQuery,
  };

  const queryString = Object.keys(params)
    .filter(key => params[key])
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
    .join('&');


  window.history.replaceState(
    {},
    null,
    `${hash}${$route.path}${queryString ? `?${queryString}` : ''}`,
  );
}

export default {
  desktopImageUrl,
  kioskImageUrl,
  mobileImageUrl,
  getFullName,
  capitalizeFirstLetter,
};



// WEBPACK FOOTER //
// ./src/lib/utils.js